import AccountOptionTypes from "./AccountOptionTypes";
import AccountPlanTypeClass from "./AccountPlanTypeClass";
import AccountRoleTypeClass from "./AccountRoleTypeClass";

class Account {
  constructor(
    private readonly _role: AccountRoleTypeClass = new AccountRoleTypeClass(),
    private readonly _plan: AccountPlanTypeClass = new AccountPlanTypeClass(),
    private readonly _options: AccountOptionTypes = new AccountOptionTypes()
  ) {
  }

  get role() {
    return this._role;
  }

  get plan() {
    return this._plan;
  }

  get options() {
    return this._options;
  }
}

export default Account;
